import React from 'react'
import { Card } from '@myxplor/ui'

import LocalAsyncStore from '../local-async-store'
import List from '../ui/list'
import { RegHolderName } from '../layout'
import { getRegHolder } from '../reg-holder'
import IssCasesSyncButtons from './views/sync-buttons'
import IssCaseItem from './views'
import IssCase from './details'
import ExpiryMessage from '../ui/expiry-message'

const issCasesEndpoint = base_url => `/api${base_url}`

const endPoint = ({ base_url }) => issCasesEndpoint(base_url)

const filterShape = ({ gov_record }) => {
  const { ISCaseId, StartDate, EndDate, Status } = gov_record

  return {
    ISCaseId,
    StartDate,
    EndDate,
    Status,
  }
}

export const IssCases = ({ iss_cases, base_url, id, embedded, refresh_iss_cases }) => {
  const onComplete = () => refresh_iss_cases(issCasesEndpoint(base_url))

  const listProps = {
    base_url,
    loading: iss_cases.loading,
    listComponent: IssCaseItem,
    detailComponent: IssCase,
    idField: 'gov_id',
    filterOn: filterShape,
    records: iss_cases.data,
  }

  return (
    <Card embedded={embedded} title={<RegHolderName />}>
      <ExpiryMessage service_id={id}/>
      <IssCasesSyncButtons regHolder={getRegHolder(base_url, id)} onComplete={onComplete} />
      <List {...listProps} />
    </Card>
  )
}

export default LocalAsyncStore('iss_cases', IssCases, endPoint)



// WEBPACK FOOTER //
// ./src/iss-cases/container.js